import { useWidgetConfig } from '..';
import { useTelemetry } from '../../hooks';
export const TelemetryProvider = ({ children }) => {
    const config = useWidgetConfig();
    useTelemetry(config === null || config === void 0 ? void 0 : config.disableTelemetry);
    return children;
};
